export const headerName = {
  add: "Добавить должность",
  edit: "Редактировать должность",
};
export const structuralPositionsData = {
  posName: {
    key: "posName",
    label: "Наименование должности",
    type: "text",
    required: true,
  },
  gimsSubLevel: {
    key: "gimsSubLevel",
    label: "Уровень подчиненности",
    type: "selectSearch",
    required: true,
    options: [],
  },
};

export const setOptionsSubLevel = (data) => {
  if (structuralPositionsData.gimsSubLevel.options.length === 0)
    structuralPositionsData.gimsSubLevel.options = data.map((item) => ({
      ...item,
      value: item.lvlId,
      label: item.lvlName,
      key: "gimsSubLevel",
    }));
};

export const getDataPositionsModal = () => structuralPositionsData;
